// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.CircleUpArrow = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CircleUpArrow = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var CircleUpArrow = _exports.CircleUpArrow = function CircleUpArrow(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99935 1.04199C5.05935 1.04199 1.04102 5.06033 1.04102 10.0003C1.04102 14.9403 5.05935 18.9587 9.99935 18.9587C14.9393 18.9587 18.9577 14.9403 18.9577 10.0003C18.9577 5.06033 14.9393 1.04199 9.99935 1.04199ZM9.99935 17.7087C5.74852 17.7087 2.29102 14.2512 2.29102 10.0003C2.29102 5.74949 5.74852 2.29199 9.99935 2.29199C14.2502 2.29199 17.7077 5.74949 17.7077 10.0003C17.7077 14.2512 14.2502 17.7087 9.99935 17.7087ZM12.941 8.7253C13.1852 8.96947 13.1852 9.36533 12.941 9.6095C12.8194 9.73116 12.6593 9.79281 12.4993 9.79281C12.3393 9.79281 12.1793 9.732 12.0577 9.6095L10.6243 8.17619V13.3337C10.6243 13.6787 10.3443 13.9587 9.99935 13.9587C9.65435 13.9587 9.37435 13.6787 9.37435 13.3337V8.17619L7.94104 9.6095C7.69687 9.85366 7.30101 9.85366 7.05684 9.6095C6.81268 9.36533 6.81268 8.96947 7.05684 8.7253L9.55684 6.2253C9.61434 6.1678 9.68342 6.12208 9.76009 6.09041C9.91259 6.02708 10.0851 6.02708 10.2376 6.09041C10.3143 6.12208 10.3835 6.1678 10.441 6.2253L12.941 8.7253Z",
      fill: "#212B36"
    }));
  };
});
